import React from 'react';
import { Card, Row, Col, Dropdown, Button } from 'antd';
import { EllipsisOutlined, FileTextOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const AirwayBillIconView = ({ airwayBills, onEdit, onDelete, onRowClick }) => {
  const getItems = (record) => [
    {
      key: 'edit',
      label: '编辑',
      icon: <EditOutlined />,
      onClick: ({ domEvent }) => {
        if (domEvent) {
          domEvent.stopPropagation();
        }
        onEdit(record);
      },
    },
    {
      key: 'delete',
      label: '删除',
      icon: <DeleteOutlined />,
      danger: true,
      onClick: ({ domEvent }) => {
        if (domEvent) {
          domEvent.stopPropagation();
        }
        onDelete(record);
      },
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {airwayBills.map((bill) => (
        <Col xs={24} sm={12} md={8} lg={6} xl={4} key={bill.id}>
          <Card
            size="small"
            onClick={() => onRowClick(bill)}
            hoverable
            style={{ cursor: 'pointer' }}
            extra={
              <Dropdown
                menu={{ items: getItems(bill) }}
                trigger={['click']}
                placement="bottomRight"
                onClick={(e) => {
                  if (e && e.stopPropagation) {
                    e.stopPropagation();
                  }
                }}
              >
                <Button type="text" icon={<EllipsisOutlined />} />
              </Dropdown>
            }
          >
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <FileTextOutlined style={{ fontSize: '24px', color: '#1890ff', marginBottom: '8px' }} />
              <div style={{ 
                fontWeight: 'bold',
                marginBottom: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {bill.airway_bill_number}
              </div>
              <div style={{ 
                fontSize: '12px',
                color: '#8c8c8c',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {bill.departure_date} {bill.arrival_date}
              </div>
              <div style={{
                fontSize: '12px',
                color: '#8c8c8c',
                marginTop: '4px'
              }}>
                批次号: {bill.batch_count} | 订单: {bill.order_count}
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AirwayBillIconView;
